import { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { post, get } from "../../utils/apiManager";
import { toast } from "react-toastify";
import { baseURL } from "../../config/config";

const Edit = () => {
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const Navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location?.search) getOneSaleCategory(location.search.split("?")[1]);
  }, []);

  const getOneSaleCategory = (id) => {
    if (id) {
      get(`/sale-category/${id}`)
        .then((res) => { if (res?.datas) setValue("name", res.datas.name); })
        .catch((err) => console.log(err));
    }
  };

  const onSubmit = (data) => {
    setLoading(true);
    data.id = location.search.split("?")[1];
    post(`${baseURL}/sale-category/edit`, data, 1)
      .then((res) => { setLoading(false); if (res?.status) Navigate("/admin/sale-category"); else toast.error(res?.message); })
      .catch((err) => { setLoading(false); toast.error(err?.response?.data?.error); });
  };

  const inputS = (err) => ({ width: '100%', padding: '10px 14px', borderRadius: 8, border: `1.5px solid ${err ? '#AD2429' : '#e2e8f0'}`, fontSize: 14, color: '#0a1628', background: '#fff', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' });

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #edf0f7', boxShadow: '0 1px 4px rgba(26,39,68,.05)', overflow: 'hidden', maxWidth: 520 }}>
        <div style={{ padding: '18px 28px', borderBottom: '1px solid #edf0f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>Edit Sale Category</h3>
            <p style={{ fontSize: 13, color: '#9aa5c0', margin: '3px 0 0' }}>Update sale category name</p>
          </div>
          <button onClick={() => Navigate('/admin/sale-category')} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>← Back</button>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} style={{ padding: '28px' }}>
          <div style={{ marginBottom: 24 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'flex', gap: 4 }}>
              Name <span style={{ color: '#AD2429' }}>*</span>
            </label>
            <input placeholder="Sale category name" type="text" style={inputS(errors.name)} {...register("name", { required: true })} />
            {errors.name && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Required</span>}
          </div>
          <div style={{ paddingTop: 16, borderTop: '1px solid #edf0f7', display: 'flex', gap: 12 }}>
            <button type="submit" disabled={loading} style={{ background: '#AD2429', color: '#fff', border: 'none', borderRadius: 8, padding: '11px 28px', fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit', opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Saving...' : 'Update Category'}
            </button>
            <button type="button" onClick={() => Navigate('/admin/sale-category')} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '11px 22px', fontSize: 15, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Edit;
